import React, { useState } from 'react';
import Tools from '../../../Misc/Tools';

import "./core-general-button.css"

const CoreGeneralButton = (props: GeneralButtonConfig) => {
	const [isHighlighted, setIsHighlighted] = useState(false);
	return (
		<div className="main-content-inner core-general-buttoncontainer" id={props.idFor508} tabIndex={0} aria-label={props.ariaLabel} style={{
			width: props.width,
			height: props.height,
			backgroundColor: props.isDisabled ? 'gray' : (props.isSelected ? 'gray' : (isHighlighted ? props.hoverColor : props.bgColor)),
			pointerEvents: props.isDisabled ? 'none' : 'all',
			...props.style
		}} onKeyUp={Tools.mapDivEnterToClick} onMouseEnter={() => {
			setIsHighlighted(true);
		}} onMouseOut={() => {
			setIsHighlighted(false);
		}} onClick={props.onClick}>
			{props.onRenderContent()}
		</div>
	);

};

export interface GeneralButtonConfig {
	onClick: () => void;
	onRenderContent: () => any;
	ariaLabel: string;
	width: string;
	style?: any;
	height: string;
	isSelected?: boolean;
	isDisabled?: boolean;
	bgColor?: string;
	hoverColor?: string;
	idFor508?: string;
}

export default CoreGeneralButton;